export const menus = [
    {
        name: 'Home',
        link: '/',
    },
    {
        name: 'Products',
        link: '/',
    },
    {
        name: 'Collection',
        link: '/',
    },
]